import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { style } from '../../utils/style.js';
import { Icon } from '../Icon/Icon.js';
import { filterOptions } from './filterOptions.js';
import { formatOption } from './formatOption.js';
export const SelectPopup = JSX(({ popupRef, options, value, query, onChange, iconVersion }) => options?.length ? (_jsx("div", { className: "bg-white text-l max-h-64 overflow-y-auto overflow-x-hidden rounded-md shadow-2xl", role: "list", ref: popupRef, children: filterOptions(options, query).map((option) => (_jsxs("div", { className: "flex px-m py-s cursor-pointer hover:bg-main-divider pr-5xl relative", role: "listitem", "aria-selected": option.key === value?.key, onClick: (e) => {
            e.stopPropagation();
            if (onChange) {
                onChange(option);
            }
        }, children: [_jsx("span", { className: "min-h-6", children: formatOption(option) }), _jsx(Icon, { name: "DoneSimpleIcon", width: "16", height: "16", iconVersion: iconVersion, className: style('absolute right-4 pt-3xs', {
                    hidden: option.key !== value?.key,
                }) })] }, option.key))) })) : null);
//# sourceMappingURL=SelectPopup.js.map